import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getPosts } from "./postsAPI";

const initialState = {
  posts: [],
  isLoading: false,
  isError: false,
  error: "",
};

export const fetchPosts = createAsyncThunk("posts/fetchPosts", async () => {
  const result = await getPosts();

  return result;
});

const postsSlice = createSlice({
  name: "posts",
  initialState,
  extraReducers: (Builder) => {
    Builder.addCase(fetchPosts.pending, (state, action) => {
      state.isLoading = true;
      state.isError = false;
    })
      .addCase(fetchPosts.fulfilled, (state, action) => {
        state.isLoading = false;
        state.posts = action.payload;
      })
      .addCase(fetchPosts.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.error = action.error?.message;
        state.posts = [];
      });
  },
});

export default postsSlice.reducer;
